import { Activity, BookOpen, Building2, Home, LockKeyhole, Wrench } from "lucide-react";

export const navigation = [
  { label: "Workspace", items: [
    { href: "/", label: "Overview", icon: Home, tone: "neutral" },
    { href: "/tokens", label: "Token intelligence", icon: Activity, tone: "blue" },
    { href: "/tools", label: "Explore", icon: Wrench, tone: "neutral" },
  ] },
  { label: "Explore", items: [
    { href: "/startups", label: "Startups", icon: Building2, tone: "violet" },
    { href: "/blog", prefixes: ["/blog/"], label: "Notes", icon: BookOpen, tone: "neutral" },
  ] },
] as const;
export const privateNavigation = [{ label: "Private workspace", items: [{ href: "/tools/rent-breakdown", label: "Rent breakdown", icon: LockKeyhole, tone: "neutral" }] }];
export const normalizePath = (path: string) => path.replace(/\/index\.html$/, "").replace(/\/$/, "") || "/";
export const isNavigationCurrent = (item: { href: string; aliases?: readonly string[]; prefixes?: readonly string[] }, path: string) => item.href === path || Boolean(item.aliases?.includes(path) || item.prefixes?.some((prefix) => path.startsWith(prefix)));
export const currentNavigation = (path: string) => [...navigation, ...privateNavigation].flatMap((group) => [...group.items]).find((item) => isNavigationCurrent(item, path));
